import { IRender } from '../parseTreeToHtml.types';

export const boldAndItalicRender: IRender = (text): string => {
  if (!text) {
    return '';
  }

  return `<b><i>${text}</i></b>`;
};
